import "core-js/modules/es.array.push.js";
import { ref } from 'vue';
import { Search, Popup, Button, Picker, Checkbox, CheckboxGroup, Tab, Tabs, Col, Row, closeToast, showLoadingToast, showDialog } from 'vant';
import { useRouter } from 'vue-router';
import { postue } from '../../api/utils/request.ts';
// const app = getApp();
export default {
  setup() {
    const currentType = ref('');
    const curType = ref('');
    const checkedlist = ref([]);
    const showPicker = ref(false);
    const showMore = ref(false);
    const sortType = ref('asc');
    const condition = ref('');
    const Province = ref('');
    const City = ref('');
    const selectedValues = ref([]);
    const columns = ref([]);
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const NotFind = ref(false);
    const toggleScreen = t => {
      showPicker.value = true;
    };
    const customFieldName = {
      text: 'cityName',
      value: 'cityName',
      children: 'cities'
    };
    // const onConfirm1 = ({ selectedValues }) => {
    //     showPicker.value = false;
    //     Province.value=selectedValues[0]
    //     City.value=selectedValues[1]
    //   console.log(selectedValues)
    // };
    const onCancel = t => {
      showPicker.value = false;
    };
    return {
      currentType,
      condition,
      curType,
      showPicker,
      showMore,
      checkedlist,
      toggleScreen,
      onCancel,
      sortType,
      columns,
      customFieldName,
      Province,
      City,
      selectedValues,
      list,
      loading,
      finished,
      NotFind
    };
  },
  data() {
    return {
      MyDeviceListForShow: [],
      sizeplus: 10,
      Brand: '',
      KID: '',
      currentType_sb: 0,
      //设备tab
      excavatorSizeslist: [],
      macTypelist: [],
      tagList: [],
      hotBrandlist: [],
      areaList: [{
        Key: '全部',
        Value: '全部',
        Checked: false
      }, {
        Key: '臺灣地區',
        Value: '臺灣地區',
        Checked: false
      }, {
        Key: '其它地區',
        Value: '其它地區',
        Checked: false
      }],
      m_excavatorSizeslist: [],
      m_macTypelist: [],
      m_arealist: [],
      m_tagList: [],
      m_hotBrandlist: [],
      DrivingMode: [],
      PlatformHigh: [],
      checkarea: [],
      checkSize: [],
      checkMacTypes: [],
      checkTags: [],
      checkhotbrand: [],
      checkmodel: [],
      checkhigh: [],
      isshowother: false
    };
  },
  created() {
    //在组件实例处理完所有与状态相关的选项后调用。
    console.log('created');
  },
  mounted() {
    //在组件被挂载之后调用 
    console.log('mounted');
    // this.getDeviceShow(this.sizeplus);
    this.GetOtherMacType();
    this.More_GetOtherMacType();
  },
  methods: {
    onLoad() {
      this.getDeviceShow(this.sizeplus, 1);
    },
    reload(type) {
      this.loading = true;
      this.sizeplus = type == 1 ? this.sizeplus : 10;
      this.finished = false;
    },
    back() {
      this.showMore = false;
      this.getDeviceShow(this.sizeplus);
    },
    //#region 標籤查詢

    //q地区
    TagcheckChange_area: function (e) {
      if (e == "更多") {
        this.gosbmore();
        return !1;
      }
      if (e == "全部") {
        this.checkarea = ['全部'];
        this.getDeviceShow(this.sizeplus);
        return !1;
      } else if (this.checkarea.includes('全部')) {
        this.checkarea.pop();
      }
      if (this.checkarea.includes(e)) {
        this.checkarea.splice(this.checkarea.indexOf(e), 1);
      } else {
        this.checkarea.push(e);
      }
      this.getDeviceShow(this.sizeplus);
    },
    //標籤
    TagcheckChange_tag: function (e) {
      if (e == "更多") {
        this.gosbmore();
        return !1;
      }
      if (e == "全部") {
        this.checkTags = ['全部'];
        this.getDeviceShow(this.sizeplus);
        return !1;
      } else if (this.checkTags.includes('全部')) {
        this.checkTags.pop();
      }
      if (this.checkTags.includes(e)) {
        this.checkTags.splice(this.checkTags.indexOf(e), 1);
      } else {
        this.checkTags.push(e);
      }
      this.getDeviceShow(this.sizeplus);
    },
    //設備
    TagcheckChange_size: function (e) {
      if (e == "更多") {
        this.gosbmore();
        return !1;
      }
      if (e == "全部") {
        this.checkSize = ['全部'];
        this.getDeviceShow(this.sizeplus);
        return !1;
      } else if (this.checkSize.includes('全部')) {
        this.checkSize.pop();
      }
      if (this.checkSize.includes(e)) {
        this.checkSize.splice(this.checkSize.indexOf(e), 1);
      } else {
        this.checkSize.push(e);
      }
      this.getDeviceShow(this.sizeplus);
    },
    //設備
    TagcheckChange_mac: function (e) {
      if (e == "更多") {
        this.gosbmore();
        return !1;
      }
      if (e == "全部") {
        this.checkMacTypes = ['全部'];
        this.getDeviceShow(this.sizeplus);
        return !1;
      } else if (this.checkMacTypes.includes('全部')) {
        this.checkMacTypes.pop();
      }
      if (this.checkMacTypes.includes(e)) {
        this.checkMacTypes.splice(this.checkMacTypes.indexOf(e), 1);
      } else {
        this.checkMacTypes.push(e);
      }
      this.getDeviceShow(this.sizeplus);
    },
    //設備
    TagcheckChange_brand: function (e) {
      if (e == "更多") {
        this.gosbmore();
        return !1;
      }
      if (e == "全部") {
        this.checkhotbrand = ['全部'];
        this.getDeviceShow(this.sizeplus);
        return !1;
      } else if (this.checkhotbrand.includes('全部')) {
        this.checkhotbrand.pop();
      }
      if (this.checkhotbrand.includes(e)) {
        this.checkhotbrand.splice(this.checkhotbrand.indexOf(e), 1);
      } else {
        this.checkhotbrand.push(e);
      }
      this.getDeviceShow(this.sizeplus);
    },
    //#endregion
    TapCurrentSb: function () {
      console.log(this.currentType_sb);
      this.MyDeviceListForShow = [];
      this.checkarea = [];
      this.checkSize = [];
      this.checkMacTypes = [];
      this.checkTags = [];
      this.checkhotbrand = [];
      this.getDeviceShow(this.sizeplus);
    },
    onConfirm() {
      console.log(this.selectedValues);
      this.showPicker = false;
      this.Province = this.selectedValues[0];
      this.City = this.selectedValues[1] == '全部' ? '' : this.selectedValues[1];
      console.log(this.selectedValues);
      this.getDeviceShow(10);
    },
    orderBy: function (t) {
      this.curType = '';
      this.showPicker = false;
      this.currentType = t;
      var s = this.sortType;
      this.sortType = s == 'desc' ? 'asc' : 'desc';
      this.getDeviceShow(this.sizeplus);
    },
    getDeviceShow: function (Psize, type) {
      //设备展示
      console.log(type);
      this.reload(type);
      console.log(this.sizeplus);
      showLoadingToast({
        message: '加載中...',
        forbidClick: true,
        duration: 0
      });
      var param = {
        PageIndex: 1,
        PageSize: Psize,
        sidx: this.currentType,
        sord: this.sortType,
        MacTypeList: this.currentType_sb == 0 ? ['挖掘機'] : this.checkMacTypes.length == 0 && this.currentType_sb == 1 ? ['全部'] : this.checkMacTypes,
        TagList: this.checkTags,
        AreaList: this.checkarea,
        BrandList: this.checkhotbrand,
        ExcavatorSizeList: this.currentType_sb == 1 ? [] : this.checkSize,
        Province: this.Province == '全部' ? '' : this.Province,
        City: this.City,
        DrivingModeList: this.checkmodel,
        PlatformHighList: this.checkhigh
      };
      postue('Auction/RTBV2/GetShowListV2', param).then(res => {
        console.log(res);
        this.MyDeviceListForShow = res.data.rows;
        closeToast();
        this.loading = false;
        if (res.data.records > 0) {
          this.NotFind = false;
          if (res.data.records <= this.sizeplus) {
            this.finished = true;
          } else {
            this.sizeplus = this.sizeplus + 10;
          }
          // 
        } else {
          this.NotFind = true;
          this.finished = true;
        }
      });
    },
    GetOtherMacType: function () {
      postue('Auction/RTBV2/GetShowConditon', {}).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.excavatorSizeslist = res.data.ExcavatorSizes, this.macTypelist = res.data.MacTypes, this.tagList = res.data.Tags, this.hotBrandlist = res.data.HotBrands;
          this.columns = res.data.Provincs;
        }
      });
    },
    gosbmore: function () {
      this.showMore = true;
      //  this.$router.push({
      //   path:'choosebrand',
      //   query:{}
      //  })
    },

    goShowdetail: function (item) {
      console.log(item);
      this.$router.push({
        path: 'UEdetail',
        query: {
          kid: item.C_ASTActivityId
        }
      });
    },
    //#region 標籤查詢   更多
    //標籤
    More_TagcheckChange_tag: function (e) {
      if (this.checkTags.includes(e)) {
        this.checkTags.splice(this.checkTags.indexOf(e), 1);
      } else {
        this.checkTags.push(e);
      }
    },
    //設備
    More_TagcheckChange_size: function (e) {
      if (this.checkSize.includes(e)) {
        this.checkSize.splice(this.checkSize.indexOf(e), 1);
      } else {
        this.checkSize.push(e);
      }
    },
    //設備
    More_TagcheckChange_mac: function (e) {
      if (this.checkMacTypes.includes(e)) {
        this.checkMacTypes.splice(this.checkMacTypes.indexOf(e), 1);
      } else {
        this.checkMacTypes.push(e);
      }
      this.isshowother = this.checkMacTypes.indexOf('高空車') == -1 ? false : true;
    },
    //設備--驅動
    More_TagcheckChange_mac_qd: function (e) {
      if (e == "全部") {
        this.checkmodel = ['全部'];
        return !1;
      } else if (this.checkmodel.includes('全部')) {
        this.checkmodel.pop();
      }
      if (this.checkmodel.includes(e)) {
        this.checkmodel.splice(this.checkmodel.indexOf(e), 1);
      } else {
        this.checkmodel.push(e);
      }
    },
    //設備--平臺高度
    More_TagcheckChange_mac_gd: function (e) {
      if (e == "全部") {
        this.checkhigh = ['全部'];
        return !1;
      } else if (this.checkhigh.includes('全部')) {
        this.checkhigh.pop();
      }
      if (this.checkhigh.includes(e)) {
        this.checkhigh.splice(this.checkhigh.indexOf(e), 1);
      } else {
        this.checkhigh.push(e);
      }
    },
    //設備
    More_TagcheckChange_brand: function (e) {
      if (this.checkhotbrand.includes(e)) {
        this.checkhotbrand.splice(this.checkhotbrand.indexOf(e), 1);
      } else {
        this.checkhotbrand.push(e);
      }
    },
    More_GetOtherMacType: function () {
      showLoadingToast({
        message: '加載中...',
        forbidClick: true,
        duration: 0
      });
      postue('Auction/RTBV2/GetOtherBrand', {}).then(res => {
        console.log(res);
        this.m_hotBrandlist = res.data;
        closeToast();
      });
      postue('Auction/RTBV2/GetOtherTags', {}).then(res => {
        console.log(res);
        this.m_tagList = res.data;
      });
      postue('Auction/RTBV2/GetOtherMacType', {}).then(res => {
        console.log(res);
        this.m_macTypelist = res.data.MacTypeList;
        this.DrivingMode = res.data.DrivingModeList;
        this.PlatformHigh = res.data.PlatformHighList;
      });
      postue('Auction/RTBV2/GetShowConditon', {}).then(res => {
        console.log(res);
        this.m_excavatorSizeslist = res.data.ExcavatorSizes;
      });
    }
  }
};